import { useTranslate } from '@growtherapy/i18n';
import { Button, Text } from '@growtherapy/sprout-ui';

import { MusicStateToggleButtonWrapper as MusicStateToggleButton } from '../background-action/MusicStateToggleButton';
import { Keyboard } from './Keyboard';
import { VibesComponentProps } from './types';

export function HorizontalVibes({ closePreSessionVibes }: VibesComponentProps) {
  const t = useTranslate();
  return (
    <div className='h-full w-full flex flex-col justify-center items-center mt-8 gap-4'>
      <div className='h-full w-full flex flex-col justify-center items-center gap-4'>
        <Text className='rebrand:text-text-inverse'>{t('telehealth-core:waitingRoom.toMakeMusicClickOnShapes')}</Text>
        <Keyboard />
      </div>
      <Button onClick={closePreSessionVibes} className='absolute bottom-3' use='secondary'>
        {t('telehealth-core:core.caretGoBack')}
      </Button>
      <div className='absolute bottom-3 right-3'>
        <MusicStateToggleButton />
      </div>
    </div>
  );
}
